import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faBars } from '@fortawesome/free-solid-svg-icons';
import AnimationContainer from '../../components/animation-container';

const Navigation = ({ change }) => {
  const [show, setShow] = useState(false);

  const sections = [
    { name: 'Home' },
    { name: 'About' },
    { name: 'Services' },
    { name: 'Portfolio' },
    { name: 'Team' },
    { name: 'Contact' },
  ];

  const navScroll = (id, index) => {
    setShow(false);

    const el = document.getElementById(id);

    if (!el) return;

    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });

    setTimeout(() => {
      if (change) {
        change(index);
      }
    }, 300);
  };

  return (
    <nav>
      <div className='opener'>
        <FontAwesomeIcon
          icon={faBars}
          className='closeNav'
          onClick={() => setShow(true)}
        />
      </div>

      <div className={`navigation ${show ? 'active' : ''}`}>
        <FontAwesomeIcon
          icon={faTimes}
          className='closeNav'
          onClick={() => setShow(false)}
        />

        <div className='links'>
          <ul>
            <AnimationContainer delay={300} animation='fadeIn slow'>
              <div className='corner-box'></div>
            </AnimationContainer>

            {sections.map((section, index) => (
              <li key={index}>
                <span
                  onClick={() => navScroll(section.name.toLowerCase(), index)}
                >
                  {section.name}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
